import { render, staticRenderFns } from "./TerrorZoneWeekTable.vue?vue&type=template&id=28312821&scoped=true"
import script from "./TerrorZoneWeekTable.vue?vue&type=script&lang=js"
export * from "./TerrorZoneWeekTable.vue?vue&type=script&lang=js"
import style0 from "./TerrorZoneWeekTable.vue?vue&type=style&index=0&id=28312821&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28312821",
  null
  
)

export default component.exports